/**
 * Datepicker
 */

export default function Datepicker() {
    const selectors = {
        'datepicker' : '.js-datepicker',
        'timepicker' : '.js-timepicker',
    };

    this.init = () => {
        jQuery(function ($) {
            "use strict";
            $(selectors.datepicker).each(function(){
                let datepicker = $(this);
                let minDate = datepicker.data("min-date");
                let maxDate = datepicker.data("max-date");
                let changeMonth = datepicker.data("change-month");
                let changeYear = datepicker.data("change-year");
                let yearRange = datepicker.data("year-range");
                let args = {}

                if(typeof minDate != "undefined") {
                    args.minDate = minDate;
                }
                if(typeof maxDate != "undefined") {
                    args.maxDate = maxDate;
                }
                if(typeof changeMonth != "undefined") {
                    args.changeMonth = changeMonth;
                }
                if(typeof changeYear != "undefined") {
                    args.changeYear = changeYear;
                }
                if(typeof yearRange != "undefined") {
                    args.yearRange = yearRange;
                }

                datepicker.datepicker(args);
            })
        });

        jQuery(function ($) {
            "use strict";
            $(selectors.timepicker).each(function(){
                let timepicker = $(this);
                let args = {
                    minutesInterval: 30,
                    now: "00:00"
                }
                timepicker.wickedpicker(args);
            })
        });
    };
}
